<app-hero-prac [heroData]="heroDataService"></app-hero-prac>
<app-show-practitioners [pracList]="practitioners"></app-show-practitioners>
